import React from "react";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";

// Scaffolding
import OuterScaffold from "../_common/OuterScaffold.react";
import Card from "../_common/Card.react";
import Container from "../_common/Container.react";

// Form items
import Input from "../_common/Input.react";
import Button from "../_common/Button.react";

// Functions
import validate from "../../functions/validate";

// Sets validation
const emailValidation = [
	{
		type: "min-length",
		value: 6
	},
	{
		type: "contains",
		value: "@"
	},
	{
		type: "contains",
		value: "."
	}
];

const passwordValidation = [
	{
		type: "min-length",
		value: 8
	}
];

const showQuery = gql`
	mutation show($view: String) {
		show(view: $view) @client
	}
`;

const loginQuery = gql`
	mutation login($email: String, $password: String) {
		login(email: $email, password: $password) @client
	}
`;

class Login extends React.Component {
	constructor(props) {
		super(props);
		this._updateFn = this._updateFn.bind(this);
		this._onClick = this._onClick.bind(this);
		this._onForgotPassword = this._onForgotPassword.bind(this);

		this.state = {
			email: "",
			password: "",
			loading: false,
			validate: false,
			errors: []
		};
	}

	componentDidMount() {
		document.getElementById("email").focus();
	}

	async _onClick() {
		var emailError = validate(emailValidation, this.state.email);
		var passwordError = validate(passwordValidation, this.state.password);

		if (emailError === "" && passwordError === "") {
			this.setState({ loading: true, validate: false });
			var result = await this.props.client.mutate({
				mutation: loginQuery,
				variables: { email: this.state.email, password: this.state.password }
			});

			if (result.data.login === true) return;

			this.setState({ loading: false, errors: [result.data.login] });
		} else this.setState({ validate: true });
	}

	_updateFn(field, location, value) {
		this.setState({ [field]: value, validate: false });
	}

	_onEmailReturn() {
		document.getElementById("password").focus();
	}

	_onForgotPassword() {
		this.props.client.mutate({
			mutation: showQuery,
			variables: {
				view: "login_resetpassword"
			}
		});
	}

	render() {
		const cardStyle = {
			width: "calc(100% - 16px)",
			padding: "16px",
			textAlign: "center"
		};

		const rowStyle = {
			width: "100%",
			textAlign: "right",
			margin: "16px 0px 0px 0px"
		};

		const logoStyle = {
			height: "100px",
			marginBottom: "30px"
		};

		const forgotStyle = {
			marginRight: "16px"
		};

		return (
			<OuterScaffold>
				<Container maxWidth="500px">
					<img src={"/images/logo_white_bg@2x.png"} style={logoStyle} alt="" />
					<Card style={cardStyle}>
						<Input
							id="email"
							label="Email"
							field="email"
							updateFn={this._updateFn}
							validate={this.state.validate}
							validation={emailValidation}
							onReturn={this._onEmailReturn}
							errors={this.state.errors}
						/>
						<Input
							id="password"
							label="Password"
							type="password"
							field="password"
							updateFn={this._updateFn}
							validate={this.state.validate}
							validation={passwordValidation}
							onReturn={this._onClick}
							errors={this.state.errors}
						/>
						<div style={rowStyle}>
							<Button text="Forgot password" style={forgotStyle} onClick={this._onForgotPassword} type="flat" />
							<Button text="LOGIN" onClick={this._onClick} loading={this.state.loading} />
						</div>
					</Card>
				</Container>
			</OuterScaffold>
		);
	}
}

export default withApollo(Login);
